<template>
  <RouterView />
  <organism-wrapper-toast-snackbar :use-store="toastSnackbarStore" />
</template>

<script lang="ts" setup>
import { useToastSnackbarStore } from '@/stores';

const toastSnackbarStore = useToastSnackbarStore();
</script>
